import { PagoTenant } from 'src/app/pago/models/PagoTenant.model';
import { SURA_TENANT } from 'src/app/pago/tenants/sura.tenant';

export const SURATECH_TENANT: PagoTenant = {
  ...SURA_TENANT,
  name: 'suratech',
};
